import React from 'react';
import Nav from "react-bootstrap/Nav";
import { useAppContext } from "../libs/contextLib";

export default function AdminLeftMenu() {
  const { userProfile } = useAppContext();

  return (  <>
            <section>
              <div id="menu">
                  <ul>
                    <li key="amn1" className="member01">
          <Nav.Link href="/admin">会員申込管理</Nav.Link>
                    </li>
                    <li key="amn2" className="member01">
                      <Nav.Link href="/admin/memberships">会員管理</Nav.Link>
                    </li>
                    <li key="amn3" className="member01">
                      <Nav.Link href="/admin/annualReports">年会費管理</Nav.Link>
                    </li>
                    <li key="amn4" className="member01">
                      <Nav.Link href="/a-signup?opt=1&mt=1">代理申込（正会員）</Nav.Link>
                    </li>
                    <li key="amn5" className="member01">
                      <Nav.Link href="/a-signup?opt=2&mt=4">代理申込（准会員）</Nav.Link>
                    </li>
                    <li key="amn6">
                      <Nav.Link href="/admin/mailHistories">メール送信履歴</Nav.Link>
                    </li>
                    <li key="amn6">
                      <Nav.Link href="/admin/downloads">ダウンロード</Nav.Link>
                    </li>
                    <li key="amn7">
                      <Nav.Link href="/">ログアウト</Nav.Link>
                    </li>
                  </ul>
                </div>
              </section>
            </>
  );
};

//export default AdminLeftMenu;
